export default "__VITE_ASSET__CxnaoBIN__"